import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { DistrictScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface SimpleSummaryDistrict {
  total_time: number
  lessons_completed: number
  student_count: number
  average_total_time_per_student: Nullable<number>
  average_total_time_per_school: Nullable<number>
  average_lexile_growth: Nullable<number>
  average_lessons_completed_per_student: Nullable<number>
  average_lessons_completed_per_school: Nullable<number>
}
export interface SimpleSummarySchool {
  school_id: number
  total_time: number
  student_count: number
  lessons_completed: number
  average_lexile_growth: Nullable<number>
  average_lessons_completed_per_student: Nullable<number>
  average_total_time_per_student: Nullable<number>
}

export interface SimpleSummaryDistrictResponse {
  simple_summary: {
    district: SimpleSummaryDistrict
    schools: SimpleSummarySchool[]
  }
}

export interface SimpleSummaryDistrictData {
  district: SimpleSummaryDistrict
  schools: SimpleSummarySchool[]
}

export async function simpleSummary(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  scope: DistrictScope,
  period: NormalizedInterval,
): Promise<Nullable<SimpleSummaryDistrictData>> {
  if (isEmpty(scope.ids)) return null
  const url = this.buildUrl('simple_summary', product, scope)
  const query = this.buildQuery(scope, period)

  const data = await this.fetchData<SimpleSummaryDistrictResponse>(url, query)

  if (!data) return null

  if (data.simple_summary.schools.length === 0) return null

  return data.simple_summary
}
